
import mutations from './mutations'
import state from './state'


export default {
  namespaced: true,
  mutations,
  state,
}